export default __webpack_public_path__ + "static/media/Broadband.c1e67329.svg";